export default __webpack_public_path__ + "static/media/ProfilePicture4.8085f66d.png";